module.exports = __webpack_public_path__ + "static/media/ceo.b69c66de.jpg";